module.exports = __webpack_public_path__ + "static/media/broken-link.31211949.svg";